export class State {
  message = {};
  loading = false;
}
